import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useTheme, useMediaQuery } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles'
import KnowledgeBase from 'src/components/knowledge-base'
import { courseFilterAction } from 'src/reducers/course/action'
import { getCollectionList } from 'src/reducers/collection/action'
import { meService } from 'src/api/authentication'
import CourseSection from './components/CourseSection'
import CollectionSection from './components/CollectionSection'

const Home = ({ classes }) => {
  const [user, setUser] = useState(window.CONSTANTS.NAME)
  const dispatch = useDispatch()
  const collection = useSelector(state => state.collection.collection)
  const courses = useSelector(state => state.course.independentCourseList)
  const collections = useSelector(state => state.collection.list)
  const [loading, setLoading] = useState(true)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    meService().then(res => {
      setUser(res.data.name)
    })
  }, [])

  useEffect(() => {
    // Fetch recent courses
    const courseQuery = {
      filterText: '',
      sortingColumn: 'createdAt',
      asc: false,
      currentPage: 0,
      pageSize: 3,
    }
    dispatch(courseFilterAction(courseQuery))

    // Fetch recent collections
    const collectionQuery = {
      filterText: '',
      currentPage: 0,
      pageSize: 3,
      sortingColumn: 'createdAt',
      asc: false,
    }
    dispatch(
      getCollectionList(collectionQuery, () => {
        setLoading(false)
      }),
    )
  }, [dispatch])

  if (loading) {
    return null
  }

  return (
    <Box className={classes.root}>
      <div className={classes.contentWrapper}>
        <Typography className={classes.greeting}>👋 Hi, {user}</Typography>
        <div className={classes.content}>
          <Box className={classes.mainContent}>
            <CourseSection
              courses={courses}
              collection={collection}
              isMobile={isMobile}
            />
            <CollectionSection collections={collections} isMobile={isMobile} />
          </Box>
          <KnowledgeBase />
        </div>
      </div>
    </Box>
  )
}

export default withStyles(styles)(Home)
